/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedFlex,
} from '../../coreui';

import StrategyRight from './components/StrategyRight';
import StrategyLeft from './components/StrategyLeft';

const Strategy = (props) => {
  const {
    valueTop,
    labelTop,
    valueBottom,
    labelBottom,
    valueRight,
    labelRight,
    ...passedProps
  } = props;
  return (
    <ExtendedFlex
      w={1}
      height="auto"
      flexDirection={['column', 'column', 'row', 'row', 'row']}
      {...passedProps}
    >
      <StrategyLeft
        valueTop={valueTop}
        labelTop={labelTop}
        valueBottom={valueBottom}
        labelBottom={labelBottom}
      />
      <StrategyRight
        header={labelRight}
        content={valueRight}
      />
    </ExtendedFlex>
  );
};

Strategy.propTypes = {
  valueTop: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  labelTop: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  valueBottom: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  labelBottom: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  valueRight: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  labelRight: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
};
export default Strategy;
